import { getFunctions, httpsCallable } from "firebase/functions";
import { log } from "../../helper/helper";
import config from "../../config.json";
import { getApp } from "firebase/app";

export function adminGetAllActiveBundledTransports(cursorBundleId) {
    let data = {};
    if (cursorBundleId !== "") {
        data = {
            cursor_bundled_id: cursorBundleId,
        };
    }
    log(data);
    log("service name: " + config.adminGetAllActiveBundledTransports)
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const allTransports = httpsCallable(functions, config.adminGetAllActiveBundledTransports);
    return allTransports(data);
}